import { useQuery } from '@tanstack/react-query'
import { qk } from 'api'
import { getAppLanguages } from 'api/languages'

export const useAppLanguages = () => {
  const { data: systemLanguages } = useQuery(
    qk.languages.appLanguages.toKey(),
    getAppLanguages,
  )

  return { systemLanguages }
}
